import { useEffect } from "react";

const STAGING_HOST_SUFFIX = ".lovable.app";

const isStaging = typeof window !== "undefined" && window.location.hostname.endsWith(STAGING_HOST_SUFFIX);

export const SeoRedirect = () => {
  useEffect(() => {
    const { pathname, search, hash } = window.location;

    if (pathname.endsWith("/index.html") && pathname !== "/index.html") {
      const cleanPath = pathname.replace(/\/index\.html$/, "");
      window.history.replaceState(null, "", `${cleanPath}${search}${hash}`);
      return;
    }

    if (isStaging) {
      // Preview hosts stay on the preview so new work can be reviewed there.
      // They are kept out of search with a noindex tag instead of a redirect.
      const meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex, nofollow";
      document.head.appendChild(meta);
    }

  }, []);

  return null;
};
